import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {GateweeIconComponent} from '../gatewee-icon/gatewee-icon.component';

/**
 * Decorative dual-chevron (“wings”) for expand/collapse affordances.
 * Pair with a real control that exposes aria-expanded; this span is aria-hidden.
 */
@Component({
  selector: 'gatewee-expand-chevron',
  standalone: true,
  imports: [CommonModule, GateweeIconComponent],
  templateUrl: './gatewee-expand-chevron.component.html',
  styleUrls: ['./gatewee-expand-chevron.component.css'],
})
export class GateweeExpandChevronComponent {
  @Input() expanded = false;
  @Input() size = '16px';
}
